import { useFavorites } from '@/hooks/useFavorites';

type Props = {
  id: string;
  className?: string;
  showLabel?: boolean;
};

export default function FavoriteButton({ id, className, showLabel = false }: Props) {
  const { isFavorite, toggleFavorite, canAdd } = useFavorites();
  const active = isFavorite(id);
  const disabled = !active && !canAdd;
  const label = active ? 'Saved to compare' : 'Save to compare';

  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleFavorite(id);
      }}
      disabled={disabled}
      aria-pressed={active}
      aria-label={active ? 'Remove from saved properties' : label}
      title={disabled ? 'You can compare up to 3 properties' : active ? 'Remove from saved' : label}
      className={`${showLabel ? 'h-10 px-3 gap-2 rounded-lg' : 'w-10 h-10 rounded-full'} flex items-center justify-center bg-background-50/90 backdrop-blur-sm border border-background-200/70 cursor-pointer transition-colors hover:bg-background-50 ${
        active ? 'text-accent-600 border-accent-300' : 'text-foreground-700'
      } ${disabled ? 'opacity-40 cursor-not-allowed' : ''} ${className ?? ''}`}
    >
      <i className={`ri-${active ? 'heart-3-fill' : 'heart-3-line'} text-lg`} />
      {showLabel && <span className="hidden sm:inline text-xs font-medium whitespace-nowrap">{label}</span>}
    </button>
  );
}
